export const replaceNewLineWithParagraph = (input) => input
    .replace(/(.*?)\n/g, '<p>$1</p>')
    .replace(/([^>]+?)$/g, '<p>$1</p>');
